@import (reference) '../../../../../constants/spacing.module.less';

.buttonRow {
  justify-content: flex-end;
  width: 100%;
  padding: @space-4 0;
  margin-bottom: @space-4;
}

.recommendButton {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 0 @space-12;
  min-height: 32px;
  white-space: nowrap;
  border: 1px solid var(--purple-8B5CF6);
  border-radius: 4px;
  background-color: var(--white);
  color: var(--purple-8B5CF6);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: var(--purple-F6F2FF);
    border-color: var(--purple-A855F7);
    color: var(--purple-A855F7);
  }
}

.sparkleIcon {
  color: var(--orange-FFA500);
  margin-right: @space-8;
  width: 14px;
  height: 14px;
}

.appliedContainer {
  background-color: var(--grey-100);
  border-radius: 4px;
  padding: @space-12;
  align-items: center;
  width: 100%;
  margin-bottom: @space-12;
  animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.appliedSparkleIcon {
  color: var(--purple-8B5CF6);
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.appliedTitle {
  flex: 1;
  font-weight: 500;
  color: var(--default--text-color--17);
  line-height: 20px;
}

.rerunButton {
  min-height: 28px;
}

.rerunIcon {
  width: 12px;
  height: 12px;
  margin-right: @space-4;
}

.closeButton {
  flex-shrink: 0;
  padding: 0;
}

.closeIcon {
  width: 16px;
  height: 16px;
  color: var(--grey-600);
}
